<template>
  <div class="layout-menu-dialog-sider">
    <div class="tree-box">
      <input-box ref="inputBox" @select="onChange" @updateGroup="$emit('updateGroup', $event)" @add="handleAddClick" />
      <div class="tree-box-content kye-scrollbar" v-clickoutside="outsideClick">
        <!-- 新增分组输入框 -->
        <add-group-input
          v-if="isAdding"
          ref="addGroupInput"
          :loading.sync="loading"
          @saved="handleAddSaved"
          @cancel="handleAddCancel"
        />
        <draggable
            ref="draggable"
            class="drag-box"
            :list="list"
            @change="onSortChange"
            v-bind="dragOptions">
          <list-item
            v-for="item in list"
            :key="item.id"
            :item="item"
            :activeId="moduleGroupId"
            @click="handleGroupClick"
            @popover-show="handlePopoverShow"
            @rename="showGroupDialog"
            @delete="remove"
          />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import Clickoutside from 'element-ui/lib/utils/clickoutside'
  import draggable from 'vuedraggable'
  import InputBox from './input-box.vue'
  import ListItem from './list-item.vue'
  import AddGroupInput from './add-group-input.vue'
  export default {
    directives: { Clickoutside },
    components: { draggable, InputBox, ListItem, AddGroupInput },
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        list: [],
        moduleGroupId: '',
        isAdding: false, // 是否正在添加新分组
        dragOptions: {
          draggable: '.list-item-draggable',
          handle: '.list-item-draggable',
          animation: 150,
          ghostClass: 'kye-ghost'
        }
      }
    },
    methods: {
      // 初始化分组列表
      async initGroupList(userId) {
        try {
          this.$emit('update:loading', true)
          const res = await this.$http('system.homeModuleGroup.list', { userId })
          this.list = res.map(item => ({ ...item, popoverShow: false, focus: false }))
          if (this.list.length > 0) {
            this.moduleGroupId = this.list[0].id
            this.$emit('change', this.list[0])
          }
        } catch (error) {
          console.error(error)
          this.list = []
        } finally {
          this.$emit('update:loading', false)
        }
      },
      // 更新分组（编辑后）
      async updateGroup(updateGroup) {
        if (updateGroup) {
          // 单个分组更新
          const index = this.list.findIndex(item => item.id === updateGroup.id)
          if (index !== -1) {
            this.$set(this.list, index, { ...this.list[index], groupName: updateGroup.groupName })
          }
          // 如果当前选中的是该分组，更新 activeItem
          if (this.moduleGroupId === updateGroup.id) {
            this.$emit('change', this.list[index])
          }
        } else {
          // 重新加载列表
          const userId = this.$store.state.user.id
          await this.initGroupList(userId)
        }
      },
      showGroupDialog(groupItem) {
        // 触发 input-box 中的弹窗
        this.$refs.inputBox.showEditDialog(groupItem)
      },
      async remove(item) {
        await this.$confirm(`你确定要删除"${item.groupName}"分组，删除后不可找回。`)
        await this.$http('system.homeModuleGroup.deleteById', { id: item.id })
        this.$message.success('删除成功！')
        // 如果删除的是当前选中的分组，清空选中状态
        if (this.moduleGroupId === item.id) {
          this.moduleGroupId = ''
          this.$emit('change', null)
        }
        // 重新加载列表
        const userId = this.$store.state.user.id
        await this.initGroupList(userId)
        this.$emit('update')
      },
      outsideClick() {
        this.list.map(item => {
          item.popoverShow = false
          item.focus = false
        })
      },
      handlePopoverShow(currentItem) {
        // 隐藏其他所有 popover，只显示当前点击的
        this.list.forEach(item => {
          if (item.id !== currentItem.id) {
            item.popoverShow = false
            item.focus = false
          }
        })
      },
      handleGroupClick(item) {
        if (item.id === this.moduleGroupId) return
        this.moduleGroupId = item.id
        this.$emit('change', item)
      },
      setModuleGroupId(id) {
        this.moduleGroupId = id || ''
      },
      async onSortChange() {
        try {
          this.$emit('update:loading', true)
          const params = this.list
            .map((item, index) => ({ id: item.id, displaySequence: index + 1 }))
            .filter(item => +item.id !== 1)
          await this.$http('system.homeModuleGroup.setModuleSort', params)
          this.$emit('update')
        } catch (error) {
          console.error(error)
        } finally {
          this.$emit('update:loading', false)
        }
      },
      onChange(item) {
        // this.moduleGroupId = item.moduleGroupId
        const group = {
          id: item.moduleGroupId,
          groupName: item.moduleGroupName
        }
        this.handleGroupClick(group)
      },
      // 点击添加按钮
      handleAddClick() {
        if (this.isAdding) return
        this.isAdding = true
        // 等待 DOM 更新后聚焦输入框
        this.$nextTick(() => {
          if (this.$refs.addGroupInput) {
            this.$refs.addGroupInput.focus()
          }
        })
      },
      // 新增分组保存成功后的处理
      async handleAddSaved() {
        // 重新加载列表
        await this.initGroupList(this.$store.state.user.id)
        this.$emit('update')
        // 隐藏输入框
        this.isAdding = false
      },
      // 取消新增
      handleAddCancel() {
        this.isAdding = false
      }
    }
  }
</script>

<style lang="scss">
.layout-menu-dialog-sider {
  width: 200px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: rgba(249, 250, 253, 1);
  padding: 16px 0;
  box-sizing: border-box;
  border-radius: 16px 0 0 16px;
  .tree-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .tree-box-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding: 0 13px 0 19px;
    .drag-box {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
  }
}
.layout-menu-dialog-sider-popover {
  min-width: 88px;
  padding: 2px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  .action-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: rgba(69, 60, 90, 1);
    cursor: pointer;
    padding-left: 12px;
    &:hover{
      background-color: rgba(245, 247, 250, 1);
    }
    &.del{
      &:hover{
        background-color: rgba(255, 41, 16, 0.1);
      }
    }
    >span{
      display: flex;
      height: 34px;
      align-items: center;
      padding: 0 12px 0 20px;
    }
    .edit{
      background: url("../../../images/edit.svg") no-repeat left center / 16px 16px;
    }
    .del{
      background: url("../../../images/delete.svg") no-repeat left center / 16px 16px;
      color: rgba(255, 41, 16, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/sider/sider.vue